import { TriageOutput } from 'enums';
import { messages } from 'i18n';

const { triageOutputLabels } = messages.submissionQueuePage;

const triageOutputConfig: Record<TriageOutput, string> = {
  [TriageOutput.InGoodOrder]: triageOutputLabels.inGoodOrder,
  [TriageOutput.NotInGoodOrder]: triageOutputLabels.notInGoodOrder,
};

export const getTriageOutputLabel = (value: TriageOutput) => triageOutputConfig[value];
